import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getDryRun = payload =>
  call(websocketFetch, 'group_invoice_dry_run', payload);
